import { render } from "./Submenu.vue?vue&type=template&id=358e41c2&lang=pug"
import script from "./Submenu.vue?vue&type=script&lang=ts"
export * from "./Submenu.vue?vue&type=script&lang=ts"
script.render = render

export default script